// extracted by mini-css-extract-plugin
export default {"wrapper":"panic_wrapper__qAYLb","tabs":"panic_tabs__7NRFM","content":"panic_content__w9RU8","table":"panic_table__HMOQC","bold":"panic_bold__MPdJE","footer":"panic_footer__koae-"};